import MindmapSDKSubjectData from "./MindmapSDKSubjectData";
import MindmapSDKTextStyleCell from "./MindmapSDKTextStyleCell";

class MindmapSDKSubjectNode {
    constructor(data) {
        this.value = data;        
        this.children = new Array();
    }

    format(vaule) {
        let mind = JSON.parse(vaule)
        let node = this.deserializeNode(mind)
        return node
    }

    deserializeNode(nodeValue) {
        let node = new MindmapSDKSubjectNode()
        for (var nodeKey in nodeValue) {
            let nodeKeyValue = nodeValue[nodeKey]
            node[nodeKey] = nodeKeyValue
            if (nodeKey == "value") {
                node[nodeKey] = this.deserializeData(nodeKeyValue);
            } else if (nodeKey == "children") {
                let children = new Array();
                let childSize = nodeKeyValue.length
                for (let index = 0; index < childSize; index++) {
                    children.push(this.deserializeNode(nodeKeyValue[index]))
                }
                node[nodeKey] = children
            }
        }
        return node
    }

    deserializeData(dataValue) {
        if (dataValue == null) {
            return new MindmapSDKSubjectData();
        }
        let mindElementData = new MindmapSDKSubjectData()
        for (var mindElementDataKey in dataValue) {
            let mindElementDataValue = dataValue[mindElementDataKey]
            mindElementData[mindElementDataKey] = mindElementDataValue
            if (mindElementDataKey == "styleCells") {
                let styleCells = []
                for (let index = 0; index < mindElementDataValue.length; index++) {
                    let cell = mindElementDataValue[index]
                    let styleCell = new MindmapSDKTextStyleCell()
                    for (var cellKey in cell) {
                        let cellValue = cell[cellKey]
                        styleCell[cellKey] = cellValue
                    }
                    styleCells.push(styleCell)
                }
                mindElementData[mindElementDataKey] = styleCells;
            }
        }
        return mindElementData
    }
}

export default MindmapSDKSubjectNode